import {
  CheckboxProps as BaseCheckboxProps,
  FormControlLabel,
  FormControlLabelProps,
  Checkbox as MuiCheckbox,
} from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import cx from 'classnames';
import { FC, useMemo } from 'react';

import { CheckboxIcon } from '@shared/icons/checkbox';
import { CheckboxPartialIcon } from '@shared/icons/checkbox-partial';

import styles from './Checkbox.styles';

export interface CheckboxProps
  extends WithStyles<typeof styles>,
    Omit<FormControlLabelProps, 'classes' | 'control' | 'label' | 'onChange'> {
  label?: React.ReactNode;
  inputProps?: BaseCheckboxProps['inputProps'] & { [k: string]: string | number };
  color?: 'primary' | 'secondary' | 'default';
  onChange?: (checked: boolean, e?: any) => any;
  direction?: 'row' | 'column';
  error?: boolean;
  partial?: boolean;
}

const CheckboxComponent: FC<CheckboxProps> = ({
  classes,
  onChange,
  label = null,
  checked,
  color = 'primary',
  inputProps,
  direction = 'row',
  error,
  partial = false,
  ...otherProps
}) => {
  const handleChange = (e: any, checked: boolean) => {
    if (onChange) {
      onChange(checked, e);
    }
  };

  const uncheckedIcon = useMemo(() => {
    if (partial) {
      return (
        <CheckboxPartialIcon
          classes={{ root: cx(classes.icon, classes.iconPartial, { [classes.iconError]: error }) }}
        />
      );
    }

    return <span className={cx(classes.icon, { [classes.iconError]: error })} />;
  }, [error, partial]);

  return (
    <FormControlLabel
      {...otherProps}
      label={<>{label}</>}
      classes={{
        root: cx(classes.root, { [classes.rootIconOnly]: !label }, { [classes.rootColumn]: direction === 'column' }),
        label: cx(classes.label, { [classes.labelError]: error }),
      }}
      control={
        <MuiCheckbox
          disableRipple
          color={color}
          inputProps={inputProps}
          classes={{
            root: classes.checkbox,
            checked: classes.checkboxChecked,
            colorPrimary: classes.checkboxPrimary,
          }}
          icon={uncheckedIcon}
          checkedIcon={
            <CheckboxIcon
              classes={{ root: cx(classes.iconChecked, { [classes.iconCheckedDisabled]: !!otherProps.disabled }) }}
            />
          }
          checked={checked}
          onChange={handleChange}
        />
      }
    />
  );
};

export const Checkbox = withStyles(styles)(CheckboxComponent);
